module.exports = __webpack_public_path__ + "img/icon_gpt3.5.3300fef9.svg";